export default __webpack_public_path__ + "static/up-ae4993b945c2cf115ad79af953dc7f13.png";